import type { FieldConfiguration } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type {
  ChartConfiguration,
  ChartStyleSettings,
  ConditionField,
  DimensionDescriptor,
  DimensionField,
  ReportField,
  SortField,
} from "../../../../../../../../api/types/svTypes.ts";
import { AreaItemType, DimensionFieldType } from "../../../../../../../../api/types/svTypes.ts";
import { valueToConfiguration } from "./configurations";

export const createChartReportConfiguration = (
  conditions: ConditionField[],
  args: DimensionField[],
  values: ReportField[],
  sorts: SortField[],
  settings: ChartStyleSettings
) => {
  const reportConfiguration: ChartConfiguration = {
    conditions: conditions.map((c) => c.config),
    arguments: args.map((field) => field.config),
    values: values.map(valueToConfiguration),
    sort: sorts.map((s) => s.config),
    settings: settings,
  };
  return reportConfiguration;
};

export const configurationToArguments = (configArgs: FieldConfiguration[], dimensions: DimensionDescriptor[]) => {
  try {
    const args = configArgs
      .map((config) => {
        const dimension = dimensions.find((d) => d.name === config.name);
        if (dimension) {
          const copied: DimensionField = {
            type: DimensionFieldType.DIMENSION,
            config,
            meta: dimension,
            areaItemType: AreaItemType.ARGUMENTS,
          };
          return copied;
        } else {
          // eslint-disable-next-line no-console
          console.log(`Field ${config.name} is not found in the dimensions' list`);
        }
        return undefined;
      })
      .filter((c): c is DimensionField => !!c);
    return args;
  } catch {
    return [];
  }
};
